#import "../fragments/automation-conditions-fragment.graphql"

fragment SlackMessageAutomation on SlackMessageAutomation {
    id
    channelId
    conditions {
        ...Condition
    }
    slackChannel {
        display
        externalId
        name
    }
}
